// removed by extract-text-webpack-plugin
module.exports = {"Spinner":"_c2kMp","Dark":"_1Dw2_","Light":"_2A1zc","White":"_2JoRr","sk-bouncedelay":"_3f5o2","Bounce1":"_18ekk","Bounce2":"_w3XOG"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/TextSpinner/TextSpinner.scss
// module id = 454
// module chunks = 0